@if (isAdmin() && hidden()) {
  <!-- панель скрыта: маленькая кнопка в углу возвращает её; число — сколько ждёт внимания -->
  <button type="button" (click)="setHidden(false)" title="Показать панель админа"
          class="fixed left-2 bottom-2 z-50 flex items-center gap-1 rounded-full border border-[var(--card-border-color)] bg-[var(--card-bg-color)] px-2.5 py-1 text-xs text-[var(--text-color-gray)] shadow hover:text-[var(--text-color)]">
    ⚙ Админ
    @if (counts()?.total) {
      <b class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-[var(--warning-bg-color)] text-[var(--warning-bg-text)] leading-none">{{counts()!.total}}</b>
    }
  </button>
} @else if (isAdmin()) {
  <div class="flex flex-wrap items-center gap-x-3.5 gap-y-1 px-3.5 py-1.5 text-sm bg-[var(--card-bg-color)] border-b border-[var(--card-border-color)] text-[var(--text-color-gray)]" role="status">
    <span class="flex flex-wrap items-center gap-x-3.5 gap-y-1">
      @if (counts(); as c) {
        @if (c.total > 0) {
          <span class="font-semibold whitespace-nowrap rounded px-1.5 bg-[var(--warning-bg-color)] text-[var(--warning-bg-text)]">⚡ Требует внимания:</span>

          @if (c.pendingComments > 0) {
            <a class="whitespace-nowrap text-[var(--primary-color)] hover:underline" [routerLink]="['/', r.admin, r.comments]">
              💬 Комментарии на модерации <b class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-[var(--primary-color)] text-[var(--on-accent)] text-xs leading-none">{{c.pendingComments}}</b>
            </a>
          }
          @if (c.pendingPayments > 0) {
            <a class="whitespace-nowrap text-[var(--primary-color)] hover:underline" [routerLink]="['/', r.admin, r.adminPayments]">
              💳 Заявки на оплату <b class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-[var(--primary-color)] text-[var(--on-accent)] text-xs leading-none">{{c.pendingPayments}}</b>
            </a>
          }
          @if (c.newUsers > 0) {
            <a class="whitespace-nowrap text-[var(--primary-color)] hover:underline" [routerLink]="['/', r.admin, r.users]">
              👤 Новые регистрации <b class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-[var(--primary-color)] text-[var(--on-accent)] text-xs leading-none">{{c.newUsers}}</b>
            </a>
          }
        }
      }
    </span>

    <!-- превью палитр — только для этого админа (localStorage) -->
    <span class="flex items-center gap-2 ml-auto" title="Превью палитры — видно только вам. Глобально: «для всех».">
      <label class="flex items-center gap-1">
        ☀️
        <select class="bg-card text-foreground border border-[var(--muted-color)] rounded px-1.5 py-0.5 text-xs"
                [value]="palette.current('light')" (change)="onPreview('light', $event)">
          @for (p of lightPalettes; track p.name) {
            <option [value]="p.name">{{p.label}}</option>
          }
        </select>
      </label>
      <label class="flex items-center gap-1">
        🌙
        <select class="bg-card text-foreground border border-[var(--muted-color)] rounded px-1.5 py-0.5 text-xs"
                [value]="palette.current('dark')" (change)="onPreview('dark', $event)">
          @for (p of darkPalettes; track p.name) {
            <option [value]="p.name">{{p.label}}</option>
          }
        </select>
      </label>
      @if (previewActive()) {
        <button type="button" class="px-1 text-xs hover:opacity-70" (click)="palette.clearPreview()" title="Сбросить превью к палитрам сайта">✕</button>
      }
      <a class="whitespace-nowrap text-[var(--primary-color)] hover:underline" [routerLink]="['/', r.admin, r.adminAppearance]" title="Палитра для всех посетителей">⚙ для всех</a>
      <button type="button" class="ml-1 px-1.5 text-base leading-none hover:text-[var(--text-color)]" (click)="setHidden(true)"
              title="Скрыть панель (вернуть — кнопка «⚙ Админ» в левом нижнем углу)" aria-label="Скрыть панель админа">✕</button>
    </span>
  </div>
}
